import type { LocalizedRelease } from "../../types";

export const releases: Record<string, LocalizedRelease> = {
  "1.1.1": {
    title: "Ronda de estabilidad",
    summary: "Correcciones del parpadeo al redibujar el canvas y de un fallo poco habitual al salir de la suspensión.",
    highlights: [
      "Corregido el parpadeo al redibujar el canvas tras un zoom rápido.",
      "Resuelto un fallo poco habitual al despertar la app de la suspensión.",
      "Menor consumo de CPU en reposo mientras el canvas está en segundo plano.",
    ],
  },
  "1.1.0": {
    title: "Canvas más rápido y bases para los agentes",
    summary: "Una ruta de rendering reconstruida, una command palette rediseñada y los cimientos para los agentes.",
    highlights: [
      "La nueva ruta de rendering mantiene el desplazamiento fluido con cientos de ventanas.",
      "Command palette rediseñada para saltar a cualquier ventana, tema o acción.",
      "Cimientos para ejecutar tareas largas de agentes directamente en el canvas.",
      "Menor huella de memoria y un arranque en frío más rápido.",
    ],
  },
  "1.0.2": {
    title: "Pulido y correcciones",
    summary: "Texto más nítido con mucho zoom y cambio de proyecto más ágil.",
    highlights: [
      "Rendering de texto más nítido en niveles de zoom altos.",
      "Cambio más rápido entre proyectos recientes.",
      "Varias correcciones en el foco de ventanas y la gestión del teclado.",
    ],
  },
  "1.0.0": {
    title: "CATE 1.0",
    summary: "La primera release estable: el canvas, los terminales, los editores y los navegadores, ya disponibles.",
    highlights: [
      "El canvas infinito con zoom, estable y listo para el día a día.",
      "Terminales, editores y navegadores como ventanas de primera clase.",
      "Espacios de trabajo persistentes que se restauran justo donde lo dejaste.",
      "Builds para macOS, Windows y Linux.",
    ],
  },
  "0.9.3": {
    title: "Refuerzo de la beta",
    summary: "Correcciones de memoria y un instalador más ligero de cara a la 1.0.",
    highlights: [
      "Cerradas varias fugas de memoria detectadas durante la beta.",
      "Reducido de forma notable el tamaño del instalador.",
    ],
  },
  "0.9.0": {
    title: "Beta pública",
    summary: "Arranca la beta pública: canvas multiventana, persistencia y temas.",
    highlights: [
      "Beta pública: cualquiera puede descargar y probar CATE.",
      "Canvas multiventana con distribuciones guardadas.",
      "Primera versión de los temas para toda la superficie.",
    ],
  },
  "0.7.0": {
    title: "Llegan los temas",
    summary: "El primer conjunto de temas integrados, aplicado a toda la superficie.",
    highlights: [
      "Temas integrados aplicados a todo el canvas, no solo al editor.",
      "Cambio instantáneo entre claro y oscuro con una tecla.",
    ],
  },
  "0.4.0": {
    title: "Canvas multipanel",
    summary: "Haz flotar más de un terminal o editor y colócalos en el espacio.",
    highlights: [
      "Abre varios terminales y editores a la vez.",
      "Arrastra las ventanas con total libertad para colocarlas en el espacio.",
    ],
  },
  "0.1.0": {
    title: "Primera alpha",
    summary: "La primera build pública: un terminal sobre un plano infinito con zoom.",
    highlights: [
      "Un terminal sobre un plano infinito con zoom.",
      "La semilla de toda la idea.",
    ],
  },
};
